import { Box, Typography } from "@mui/material";

// Page title with optional subtitle and actions. Title and actions share a
// row on wide screens and wrap under each other on phones.
export const Header = ({ title, subtitle, actions }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        gap: { xs: 1.5, sm: 2 },
        mb: { xs: 1, sm: 2 },
        width: "100%",
      }}
    >
      <Box sx={{ minWidth: 0, flex: "1 1 240px" }}>
        <Typography
          variant="h2"
          component="h1"
          color="text.primary"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            "& img": { flexShrink: 0 },
            overflowWrap: "anywhere",
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="body1"
            color="text.secondary"
            title={typeof subtitle === "string" ? subtitle : undefined}
            sx={{
              mt: 0.5,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 1,
          }}
        >
          {actions}
        </Box>
      )}
    </Box>
  );
};
